import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import Login from './pages/Login';
import TeacherDashboard from './pages/TeacherDashboard';
import StudentQuizCreation from './pages/StudentQuizCreation';
import QuizSession from './pages/QuizSession';
import QuizDashboard from './pages/QuizDashboard';
import GNB from './components/GNB';
import TopGNB from './components/TopGNB';
import Profile from './pages/Profile';
import AIQuiz from './pages/AIQuiz';

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const { currentUser } = useAuth();

  return (
    <div className="flex flex-col min-h-screen">
      <div className="app-background"></div>
      {!isHomePage && <TopGNB />}
      <div className="flex-grow overflow-auto"> {/* pt-16 제거 */}
        <div className="">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
            <Route path="/quiz-dashboard/:quizId" element={<QuizDashboard />} />
            <Route path="/create-quiz/:code" element={<StudentQuizCreation />} />
            <Route path="/quiz-session/:id" element={<QuizSession />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/ai-quiz" element={<AIQuiz />} />
          </Routes>
        </div>
      </div>
      {currentUser && <GNB />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
